import { IListViewParameter, INavigationParameterProvider } from '#/CoreFrameInterfaces';
import ComponentManager from '@/Management/ComponentManager';
import RADApplication from '@/Management/RADApplication';
import Address from '@/Model/Address';
import * as DateHelper from '@/Utility/DateHelper';
import Utilities from '@/Utility/Utilities';

export default class DefaultNavigationParameterProvider implements INavigationParameterProvider {

    public addDetailViewParameters(addr: Address, params: any): void {
        if (params == null) {
            return;
        }

        addr.onNavigated(params != null ? params.onNavigated : null);

        if (!isNaN(params.pdoId) && params.pdoId > 0) {
            addr.setParameter('PdoId', params.pdoId);
        }

        if (!String.isNullOrEmpty(params.contextId)) {
            addr.setHiddenParameter('ContextID', params.contextId);
        }

        if (!isNaN(params.contextObject) && params.contextObject > 0) {
            addr.setHiddenParameter('ContextObject', params.contextObject);
        }

        if (!String.isNullOrEmpty(params.contextTypeName)) {
            addr.setHiddenParameter('ContextTypeName', params.contextTypeName);
        }

        if (!String.isNullOrEmpty(params.contextRelation)) {
            addr.setHiddenParameter('ContextRelation', params.contextRelation);
        }

        if (!Utilities.isNullOrUndefined(params.contextParameters)) {
            addr.setHiddenParameter('ContextParameters', params.contextParameters);
        }

        if (!String.isNullOrEmpty(params.listViewId)) {
            addr.setParameter('ViewID', params.listViewId);
        }
    }

    public addListViewParameters(addr: Address, params: IListViewParameter) {
        if (params == null) {
            return;
        }

        addr.onNavigated(params != null ? params.onNavigated as any : null);

        if (!String.isNullOrEmpty(params.preFilter)) {
            if (params.preFilter.length > 500)
                addr.setHiddenParameter('PreFilter', params.preFilter);
            else
                addr.setParameter('PreFilter', params.preFilter);
        }

        if (!String.isNullOrEmpty(params.filter)) {
            addr.setParameter('Filter', params.filter);
        }

        if (!String.isNullOrEmpty(params.serializedFilter)) {
            addr.setParameter('SerializedFilter', params.serializedFilter);
        }

        if (params.forceSelectingLVByName === true || params.forceSelectingLVByName === false) {
            addr.setHiddenParameter('forceSelectingLVByName', params.forceSelectingLVByName);
        }

        if (!Utilities.isNullOrUndefined(params.notDeletableIds)) {
            addr.setHiddenParameter('notDeletableIds', params.notDeletableIds);
        }

        if (!Utilities.isNullOrUndefined(params.showButtonCreate)) {
            addr.setHiddenParameter('showButtonCreate', params.showButtonCreate);
        }

        if (!Utilities.isNullOrUndefined(params.showButtonEdit)) {
            addr.setHiddenParameter('showButtonEdit', params.showButtonEdit);
        }

        if (!Utilities.isNullOrUndefined(params.showButtonDelete)) {
            addr.setHiddenParameter('showButtonDelete', params.showButtonDelete);
        }

        const selectedPdo = +params.selectedPDO;
        if (!isNaN(selectedPdo) && selectedPdo > 0) {
            addr.setParameter('SelectedPDO', selectedPdo);
        }

        if (!String.isNullOrEmpty(params.contextTypeName)
            && +params.contextObject > 0
            && !String.isNullOrEmpty(params.contextRelation)
        ) {
            addr.setHiddenParameter('ContextTypeName', params.contextTypeName);
            addr.setHiddenParameter('ContextObject', params.contextObject);
            addr.setHiddenParameter('Assoziation', params.contextRelation);
            addr.setHiddenParameter('IgnoreContext', params.ignoreContext);
        }

        if (!String.isNullOrEmpty(params.titleExtension)) {
            addr.setParameter('TitleExtension', params.titleExtension);
        }

        if (!String.isNullOrEmpty(ko.unwrap(params.principalFilterMode) as any)) {
            const principalFilterMode = RADApplication.getInstance().getClientValueForPrincipalFilterMode(ko.unwrap(params.principalFilterMode) as any);
            addr.setHiddenParameter('PrincipalMode', principalFilterMode);
        }

        if (params.showPrincipalFilter === false) {
            addr.setHiddenParameter('ShowPrincipalButton', false);
        }

        if (!Boolean.isNullOrUndefined(params.disablePrincipalFilter)) {
            addr.setHiddenParameter('DisablePrincipalFilter', params.disablePrincipalFilter);
        }

        if (params.historyDate != undefined && params.historyDate != '') {
            let historyDateTicks = -1;
            if (params.historyDate instanceof Date) {
                historyDateTicks = DateHelper.dateToTicks(params.historyDate);
            }
            else if (typeof params.historyDate == 'number') {
                historyDateTicks = params.historyDate;
            }
            // Nur für .Net-Date-Strings!
            else if (typeof params.historyDate == "string") {
                historyDateTicks = DateHelper.dateToTicks(DateHelper.parseDotNetDateString(params.historyDate));
            }

            if (historyDateTicks > 0) {
                addr.setParameter('HistoryDate', historyDateTicks);
            }
        }
    }

    public addExtensionViewParameters(addr: Address, params: any): void {
        if (params == null) {
            return;
        }

        addr.onNavigated(params != null ? params.onNavigated : null);

        params = $.extend(true, {}, params);
        delete params.navigateTo;

        addr.setParameters(params);
    }
    
}

ComponentManager.setUtility('NavigationParameterProvider', DefaultNavigationParameterProvider, 'RADPresentation.HTMLClient.DefaultViewExtensions');